import React from "react";
import { RelabelCaseStatus } from "src/types";
import { RELABEL_CASE_STATUS_LABEL, RELABEL_CASE_STATUS_STYLE } from "src/constants/relabelCases";

interface StatusPillProps {
  status: RelabelCaseStatus;
}

const StatusPill: React.FC<StatusPillProps> = ({ status }) => {
  const { pill, dot } = RELABEL_CASE_STATUS_STYLE[status];
  return (
    <span className={`inline-flex items-center gap-1.5 rounded-full px-2.5 py-1 text-xs font-medium ${pill}`}>
      <span className={`h-1.5 w-1.5 rounded-full shrink-0 ${dot}`} />
      {RELABEL_CASE_STATUS_LABEL[status]}
    </span>
  );
};

export { StatusPill };
